<template>
    <div class="card white-card shadow-sm">
        <div class="card-body">
            <h4 class="card-title mb-3">Manage Account Subscription</h4>
            <div>
                <div class="row small-card-content">
                    <div class="col-9">
                        <div class="align-items-center">
                            All Customily billing and subscription actions are managed on your Shopify Apps and Sales
                            Channels section, whether you want to view your invoices or uninstall the app from
                            yourShopify store. For extra guidance, see our
                            <a :href="customilyHelpLink" target="_blank" rel="noopener noreferrer">Help Center</a>.
                        </div>
                    </div>
                    <div class="col d-flex align-items-end justify-content-end">
                        <a :href="adminShopifyLink" target="_blank" rel="noopener noreferrer" class="btn btn-primary"
                            >Manage Subscriptions <font-awesome-icon :icon="['far', 'arrow-up-right-from-square']" />
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const customilyHelpLink =
    'https://help.customily.com/hc/en-us/articles/15994176886043-How-to-pause-or-cancel-your-Customily-account';
const adminShopifyLink = 'https://admin.shopify.com/';
</script>
